import { workingDaysBetween } from './calendar';
export function compareToBaseline(current, baseline, calendar) {
    const planned = new Map(baseline.map((entry) => [entry.taskId, entry]));
    const result = new Map();
    for (const task of current) {
        const plan = planned.get(task.taskId);
        if (!plan) {
            // Added after the baseline was taken. Not "zero variance" - there is
            // nothing to compare against, and saying zero would hide that.
            result.set(task.taskId, {
                taskId: task.taskId,
                startVariance: null,
                finishVariance: null,
                durationVariance: 0,
                inBaseline: false,
            });
            continue;
        }
        result.set(task.taskId, {
            taskId: task.taskId,
            startVariance: task.start === null ? null : workingDaysBetween(calendar, plan.start, task.start),
            finishVariance: task.finish === null ? null : workingDaysBetween(calendar, plan.finish, task.finish),
            durationVariance: task.durationDays - plan.durationDays,
            inBaseline: true,
        });
    }
    return result;
}
/** The largest finish slip across all tasks, for a one-line summary. */
export function worstFinishVariance(variances) {
    let worst = null;
    for (const variance of variances) {
        if (variance.finishVariance === null)
            continue;
        worst = worst === null ? variance.finishVariance : Math.max(worst, variance.finishVariance);
    }
    return worst;
}
//# sourceMappingURL=baseline.js.map